import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { UsuarioUnidade } from 'src/app/models/usuario-unidade';
import { UsuarioService } from 'src/app/services/http/usuario.service';
import { LoginService } from 'src/app/services/login.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { UserConfigsUtils } from 'src/app/utils/UserConfigsUtils';
import { UtilValidators } from 'src/app/utils/util-validators';

@Component({
  selector: 'app-form-nova-senha',
  templateUrl: './form-nova-senha.component.html',
  styleUrls: ['./form-nova-senha.component.scss']
})
export class FormNovaSenhaComponent implements OnInit {
  id = null;
  usuario = new UsuarioUnidade([]);
  form = new FormGroup({
    senha: new FormControl('', [
      Validators.required,
      UtilValidators.senhaComCaracterEspecial,
      UtilValidators.senhaComMaiuscula,
      UtilValidators.senhaComMinuscula,
      UtilValidators.senhaComNumero,
      Validators.minLength(8),
      Validators.maxLength(100)
    ]),
    senhaConf: new FormControl('', [Validators.required, UtilValidators.equalValidator('senha')]),
  });

  constructor(private route: Router, private location: Location, private activatedRoute: ActivatedRoute, private usuarioService: UsuarioService, private modalMsgService: ModalMsgService, private modalService: NgbModal, private loginService: LoginService) {
  }

  ngOnInit() {
    let ret = this.loginService.decodeToken(this.loginService.getTokenLogin());
    //this.id = this.activatedRoute.snapshot.params.id || ret.uuid || null;
    this.usuarioService.getUsuario(ret.uuid).then(u => this.usuario = u).catch((e) => {
      this.modalMsgService.openDialog('Sem permissão para alterar este usuario', '', 'danger')
        .finally(() => this.route.navigate(['usuario']));
    });
  }

  sendForm() {
    if (this.form.invalid) {
      this.form.controls.senha.markAsTouched();
      this.form.controls.senhaConf.markAsTouched();
      this.modalMsgService.openDialog('Dados inválidos', 'Preencha o formulário corretamente', 'danger');
      return;
    }

    this.usuario.senha = this.form.controls.senha.value;


    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Alterar senha';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.usuarioService.alterarSenhaUsuario({
          ip: UserConfigsUtils?.getUserConfigsStorage()?.ip || "",
          ...this.usuario
        }, justificativa)
        .then(r => { 
          this.modalMsgService.openDialog('Senha alterada com sucesso', '', 'success')
          .finally(() => this.location.back());
        })
        .catch(e => {
          console.log(e);
          if(e.status === 400) {
            this.modalMsgService.openDialog( e.error.message, '', 'danger')
          } else {
            this.modalMsgService.openDialog('Erro ao alterar senha', '', 'danger')
          }
        });
      } else {
        this.modalMsgService.openDialog('Erro ao alterar senha',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao alterar senha',
      'Informe uma Justificativa para concluir a operação', 'danger'));

  }

  cancelar() {
    this.location.back();
  }

}
